import { createApp } from 'vue'
import WebshopPaymentSelector from './WebshopPaymentSelector'

const el = '.kb-component--webshop-payment-selector'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((WebshopPaymentSelectorDOM) => {
            const component = createApp(WebshopPaymentSelector).use(Store)
            component.mount(WebshopPaymentSelectorDOM)
        })
    }
}
